import { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Select from 'react-select';
import CountUp from 'react-countup';
import {
    RotateCcw, Ship, Microscope, Activity,
    Search, Fish, Bird, Ruler, PieChart, Binoculars,
    Download, FileSpreadsheet, Database
} from 'lucide-react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';

import Footer from '../../../components/Footer.jsx';
import Disclaimer from '../../../components/Disclaimer.jsx';
import TourGuiaPublico from '../../../components/TourGuiaPublico.jsx';

import LoginModal from '../../../components/Auth/LoginModal.jsx';
import RegisterModal from '../../../components/Auth/RegisterModal.jsx';
import ForgotPasswordModal from '../../../components/Auth/ForgotPasswordModal.jsx';

import { useAuth } from '../../../contexts/AuthContext.jsx';

import './pages.css';

const ICON_CONFIG = {
    'Bitácora de pesca': <Ship size={20} className="text-primary" />,
    'Captura incidental': <Fish size={20} className="text-danger" />,
    'Censo aves marinas': <Bird size={20} className="text-info" />,
    'Interacción con otras especies': <Activity size={20} className="text-success" />,
    'Muestreo biologico': <Microscope size={20} className="text-primary" />,
    'Muestreo de longitud': <Ruler size={20} className="text-warning" />,
    'Muestreo longitud': <Ruler size={20} className="text-warning" />,
    'Muestreo proporcion de especies': <PieChart size={20} className="text-secondary" />,
    'Presencia otras especies': <Binoculars size={20} className="text-dark" />,
    'REGISTRO DIARIO DE CAPTURAS': <FileSpreadsheet size={20} className="text-info" />,
    'Registro diario de capturas': <FileSpreadsheet size={20} className="text-info" />,
};

const customStyles = {
    control: (styles) => ({
        ...styles,
        borderRadius: '0.75rem',
    })
};

const getBadgeClass = (group) => {
    const g = group.toLowerCase().trim();
    if (g.includes('bitácora')) return 'badge-bitacora';
    if (g.includes('captura incidental')) return 'badge-captura';
    if (g.includes('censo aves')) return 'badge-aves';
    if (g.includes('interacción')) return 'badge-interaccion';
    if (g.includes('muestreo biologico')) return 'badge-muestreo';
    if (g.includes('muestreo de longitud') || g.includes('muestreo longitud')) return 'badge-longitud';
    if (g.includes('muestreo proporcion')) return 'badge-proporcion';
    if (g.includes('presencia otras')) return 'badge-presencia';
    return '';
};

const PesqueriaNuevoV2Page = ({ verifyToken }) => {
    const [fetch, setFetch] = useState(false);
    const [selectores, setSelectores] = useState(false);
    const [buscar, setBuscar] = useState(false);
    const [filter, setFilter] = useState(false);
    const [regiones, setRegiones] = useState(false);
    const [checkboxes, setCheckboxes] = useState(false);
    const [childCheckboxes, setChildCheckboxes] = useState(false);
    const [descargar, setDescargar] = useState(false);
    const [nombreArchivo, setNombreArchivo] = useState({});
    const [estadisticas, setEstadisticas] = useState([]);
    const [codigoEspecie, setCodigoEspecie] = useState(0);
    const [selectorEspecies, setSelectorEspecies] = useState([]);
    const [valueEspecie, setValueEspecie] = useState(null);
    const [anioDisponible, setAnioDisponible] = useState(0);
    const [selectorAnios, setSelectorAnios] = useState([]);
    const [valueAnio, setValueAnio] = useState(null);
    const [codigoPuerto, setCodigoPuerto] = useState(0);
    const [selectorPuertos, setSelectorPuertos] = useState([]);
    const [codigoRegion, setCodigoRegion] = useState(0);
    const [selectorRegiones, setSelectorRegiones] = useState([]);
    const [valuePuerto, setValuePuerto] = useState(null);
    const [valueRegion, setValueRegion] = useState(null);
    const [archivos, setArchivos] = useState([]);
    const [tiposInformacion, setTiposInformacion] = useState([]);
    const [checkboxesTiposInformacion, setCheckboxesTiposInformacion] = useState({});
    const [subtiposInformacion, setSubtiposInformacion] = useState([]);
    const [checkboxesSubtiposInformacion, setCheckboxesSubTiposInformacion] = useState({});
    const [descargas, setDescargas] = useState([]);
    const [descargasConsolidadas, setDescargasConsolidadas] = useState([]);
    const [checkboxesDescargasConsolidadas, setCheckboxesDescargasConsolidadas] = useState({});
    const [params, setParams] = useState({});
    const [paramsConsolidados, setParamsConsolidados] = useState({});
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
    const [enabledTour, setEnabledTour] = useState(false);

    const { api, setEmail, setPassword, token } = useAuth();

    const publicUrl = process.env.PUBLIC_URL;
    const appDebug = process.env.REACT_APP_DEBUG;
    const apiUrl = process.env.REACT_APP_API_URL;
    const repositorioUrl = process.env.REACT_APP_REPOSITORIO_URL;
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    const url = 'buscador-publico-pesqueria';

    const location = useLocation();

    const handleSelectorEspecie = (especie) =>
    {
        // 1. Tu lógica actual de React (actualizar estado)
        setCodigoEspecie(especie ? especie.value : 0);
        setValueEspecie(especie);

        // 2. Notificar a Google Tag Manager
        if (window.dataLayer && especie)
        {
            window.dataLayer.push(
            {
                event: 'buscador_publico_pesqueria_v1_filtro_por_especie',
                especie_seleccionada: especie.label,
                especie_id: especie.value,
            });
        }

        setSelectores(true);

        setValueAnio(null);
        setValuePuerto(null);
        setTiposInformacion([]);
        setCheckboxesTiposInformacion({});
        setArchivos([]);
        setDescargas([]);
        setDescargasConsolidadas([]);
        setCheckboxesDescargasConsolidadas({});
    };

    const handleSelectorAnio = (anio) =>
    {
        // 1. Tu lógica actual de React (actualizar estado)
        setAnioDisponible(anio ? anio.value : 0);
        setValueAnio(anio);

        // 2. Notificar a Google Tag Manager
        if (window.dataLayer && anio)
        {
            window.dataLayer.push(
            {
                event: 'buscador_publico_pesqueria_v1_filtro_por_anio',
                anio_seleccionado: anio.label,
            });
        }

        setCodigoPuerto(0);
        setValuePuerto(null);
        setTiposInformacion([]);
        setCheckboxesTiposInformacion({});
        setSubtiposInformacion([]);
        setCheckboxesSubTiposInformacion({});
        setArchivos([]);
        setDescargas([]);
        setDescargasConsolidadas([]);
        setCheckboxesDescargasConsolidadas({});
        setRegiones(true);
    };

    const handleSelectorPuerto = (puerto) =>
    {
        // 1. Tu lógica actual de React (actualizar estado)
        setCodigoPuerto(puerto ? puerto.value : 0);
        setValuePuerto(puerto);

        // 2. Notificar a Google Tag Manager
        if (window.dataLayer && puerto)
        {
            window.dataLayer.push(
            {
                event: 'buscador_publico_pesqueria_v1_filtro_por_puerto',
                puerto_seleccionado: puerto.label,
                puerto_id: puerto.value,
            });
        }

        setTiposInformacion([]);
        setCheckboxesTiposInformacion({});
        setSubtiposInformacion([]);
        setCheckboxesSubTiposInformacion({});
        setArchivos([]);
        setDescargas([]);
        setDescargasConsolidadas([]);
        setCheckboxesDescargasConsolidadas({});
    };

    const handleBuscar = () =>
    {
        // 1. Enviar los filtros activos a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'busqueda_publica_pesqueria_v1_iniciada',
                filtro_especie: valueEspecie.label,
                filtro_puerto: valuePuerto.label,
                filtro_anio: anioDisponible,
            });
        }

        // 2. Tu lógica actual de React para hacer la petición a la API
        setBuscar(true);

        setTiposInformacion([]);
        setCheckboxesTiposInformacion({});
        setSubtiposInformacion([])
        setCheckboxesSubTiposInformacion({});
    };

    const handleReset = () =>
    {
        // 1. Enviar los filtros activos a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'busqueda_publica_pesqueria_v1_reiniciada',
                filtro_especie: valueEspecie.label,
                filtro_puerto: valuePuerto.label,
                filtro_anio: anioDisponible,
            });
        }

        setFilter(false);
        setCodigoEspecie(0);
        setValueEspecie(null);
        setAnioDisponible(0);
        setSelectorAnios([]);
        setValueAnio(null);
        setCodigoPuerto(0);
        setSelectorPuertos([]);
        setValuePuerto(null);
        setArchivos([]);
        setTiposInformacion([]);
        setCheckboxesTiposInformacion({});
        setSubtiposInformacion([]);
        setCheckboxesSubTiposInformacion({});
        setDescargas([]);
        setDescargasConsolidadas([]);
        setCheckboxesDescargasConsolidadas({});
    };

    const handleCheckbox = useCallback((e, value) =>
    {
        const checked = e.target.checked;
        const tipoInformacion = value.titulo_tipo_informacion;
        const valueSubtiposInformacion = value.tipos_informacion;

        // let tiposInformacionArray = [];

        if (checked === true)
        {
            const array = [...tiposInformacion];

            /* Sublógica */

            const subArray = [];

            valueSubtiposInformacion.forEach((subtipoInformacion) =>
            {
                const label = `${subtipoInformacion.tipo_informacion} (${subtipoInformacion.acronimo})`;

                if (!subtiposInformacion.includes(label)) subArray.push(label);
            });

            subArray.push(...subtiposInformacion);

            setSubtiposInformacion(subArray);

            const subObject = {};

            subArray.forEach((value) => { subObject[value] = true; });

            setCheckboxesSubTiposInformacion({ ...subObject });

            /* Sublógica */

            array.push(tipoInformacion);

            // tiposInformacionArray = array

            setTiposInformacion(array);
        }
        else
        {
            const filter = tiposInformacion.filter(nombre => nombre !== tipoInformacion);

            /* Sublógica */

            const subArrayFalse = [];

            valueSubtiposInformacion.forEach((subtipoInformacion) =>
            {
                subArrayFalse.push(`${subtipoInformacion.tipo_informacion} (${subtipoInformacion.acronimo})`);
            });

            const subArrayTrue = subtiposInformacion.filter(subtipo => !subArrayFalse.includes(subtipo));

            setSubtiposInformacion(subArrayTrue);

            const subObjectFalse = {};

            subArrayFalse.forEach((value) => { subObjectFalse[value] = false; });

            const subObjectTrue = {};

            subArrayTrue.forEach((value) => { subObjectTrue[value] = true; });

            setCheckboxesSubTiposInformacion({ ...subObjectFalse, ...subObjectTrue });

            /* Sublógica */

            // tiposInformacionArray = filter

            setTiposInformacion(filter);
        }

        // 1. Tu lógica para actualizar el estado en React
        setCheckboxesTiposInformacion(
        {
            ...checkboxesTiposInformacion,
            [tipoInformacion]: checked
        });

        // 2. Enviar la acción a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'buscador_publico_pesqueria_v1_checkbox_tipo_informacion',
                checkbox_tipo_informacion: tipoInformacion,
                checkbox_accion: checked ? 'marcado' : 'desmarcado',
            });
        }

        setCheckboxes(true);
    }, [tiposInformacion, checkboxesTiposInformacion, subtiposInformacion, checkboxesSubtiposInformacion]);

    const handleChildCheckbox = useCallback((e, value) =>
    {
        const checked = e.target.checked;
        const subtipoInformacion = e.target.value;

        if (checked === true)
        {
            setSubtiposInformacion([...subtiposInformacion, subtipoInformacion]);
        }
        else
        {
            setSubtiposInformacion(subtiposInformacion.filter(nombre => nombre !== subtipoInformacion));
        }

        setCheckboxesSubTiposInformacion(
        {
            ...checkboxesSubtiposInformacion,
            [subtipoInformacion]: checked
        });

        descargas.forEach(descarga =>
        {
            const alias = `${descarga.NOMBRE_PROYECTO} (${descarga.ACRONIMO})`;

            if (alias === value) { setNombreArchivo({ [descarga.NOMBRE_ARCHIVO]: checked }); }
        });

        setChildCheckboxes(true);
    }, [subtiposInformacion, checkboxesSubtiposInformacion, descargas]);

    const handleOpciones = (href, archivo, url, tipoInformacion, subtipoInformacion, valueEspecie, valuePuerto, anioDisponible) =>
    {
        setParams(
        {
            href,
            archivo,
            url,
            tipo_informacion: tipoInformacion,
            subtipo_informacion: subtipoInformacion,
            especie: valueEspecie,
            puerto: valuePuerto,
            anio: anioDisponible,
        });
    }

    const handleOpcionesConsolidadas = (descargasConsolidadas, url, tiposInformacion, subtiposInformacion, valueEspecie, valuePuerto, anioDisponible) =>
    {
        setParamsConsolidados(
        {
            archivos: descargasConsolidadas,
            url,
            tipos_informacion: tiposInformacion,
            subtipos_informacion: subtiposInformacion,
            especie: valueEspecie,
            puerto: valuePuerto,
            anio: anioDisponible,
        });
    }

    const handleClick = async (archivo, url, tipoInformacion, subtipoInformacion, valueEspecie, valuePuerto, anioDisponible) =>
    {
        if (Object.keys(params).length > 0)
        {
            const link = document.createElement('a');

            link.href = params.href;

            link.setAttribute('download', archivo);

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            setParams({});
        }

        const especie = valueEspecie.label;
        const puerto = valuePuerto.label;

        const opciones = `Tipo de Información: ${tipoInformacion}, Proyecto: ${subtipoInformacion}, Especie: ${especie}, Puerto: ${puerto}`;

        try
        {
            const response = await api.post(`/v2/pesqueria/archivos/descargas/${archivo}`,
            {
                url: url,
                opciones: opciones,
                años: anioDisponible
            });

            // Enviamos todo el contexto científico a GTM
            if (window.dataLayer)
            {
                window.dataLayer.push(
                {
                    event: 'buscador_publico_pesqueria_v1_descarga_archivo',
                    archivo_nombre: archivo,
                    archivo_tipo_informacion: tipoInformacion,
                    archivo_proyecto: subtipoInformacion,
                    filtro_especie: especie,
                    filtro_puerto: puerto,
                    filtro_anio: anioDisponible,
                });
            }

            console.log(response);
        }
        catch (error)
        {
            console.error(error);
        }
    };

    const handleDescargasConsolidadas = (object) =>
    {
        const seleccionadas = Object.keys(object).filter(descarga => object[descarga] === true);

        setDescargasConsolidadas(seleccionadas);
    };

    const handleDownloadZip = async (descargasConsolidadas, url, tiposInformacion, subtiposInformacion, valueEspecie, valuePuerto, anioDisponible) =>
    {
        const especie = valueEspecie.label;
        const puerto = valuePuerto.label;

        let archivos = [];
        let opcionesCheckbox = '';

        descargasConsolidadas.forEach((archivo) =>
        {
            archivos.push(`${archivo}.xlsx`);
        });

        tiposInformacion.forEach(data =>
        {
            opcionesCheckbox += `Tipo de Información: ${data}, `;
        });

        subtiposInformacion.forEach(data =>
        {
            opcionesCheckbox += `Proyecto: ${data.replace(/\s?\([^)]*\)/g, '')}, `;
        });

        opcionesCheckbox += `Especie: ${especie}, Puerto: ${puerto}`;

        try
        {
            const zip = new JSZip();

            const descargasPromise = descargasConsolidadas.map(async (nombre) =>
            {
                const response = await api.get(`/v2/pesqueria/archivos/descargas/${nombre}/xlsx`, { responseType: 'blob' });

                zip.file(`${nombre}.xlsx`, response.data);
            });

            await Promise.all(descargasPromise);

            const content = await zip.generateAsync({ type: 'blob' });
            const timestamp = new Date().toISOString().replace(/[:T]/g, '-').slice(0, 19);

            const archivo = `descargas_consolidadas_${timestamp}.zip`;

            saveAs(content, archivo);

            const response = api.post(`/v2/pesqueria/archivos/descargas/${archivo}`,
            {
                archivos: archivos,
                url: url,
                opciones: opcionesCheckbox,
                años: anioDisponible
            });

            // Enviamos todo el contexto científico a GTM
            if (window.dataLayer)
            {
                window.dataLayer.push(
                {
                    event: 'buscador_publico_pesqueria_v1_descarga_archivo_consolidado',
                    archivo_consolidado_nombre: archivo,
                    archivo_consolidado_tipos_informacion: tiposInformacion,
                    archivo_consolidado_proyectos: subtiposInformacion,
                    filtro_especie: especie,
                    filtro_puerto: puerto,
                    filtro_anio: anioDisponible,
                });
            }

            setDescargar(false);
        }
        catch (error)
        {
            console.error(error);
        }
    };

    const filterRegiones = useCallback(async () =>
    {
        try
        {
            const response = await axios.get(`${apiUrl}/v2/pesqueria/busqueda?codigo_especie=${codigoEspecie}&anio_disponible=${anioDisponible}&environment=production`);

            const data = verifyToken(response, appDebug, secretKey);

            if (data.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setSelectorPuertos(data.puertos.map(puerto => ({ value: `${puerto.PUERTO_RECALADA}`, label: `${puerto.NOMBRE_PUERTO}` })));

            setRegiones(false);
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken, codigoEspecie, anioDisponible]);

    const filterArchivos = useCallback(async () =>
    {
        setFilter(true);

        try
        {
            const response = await axios.get(`${apiUrl}/v2/pesqueria/archivos?codigo_especie=${codigoEspecie}&anios_disponibles[]=${anioDisponible}&codigos_puertos[]=${codigoPuerto}`);

            const archivos = verifyToken(response, appDebug, secretKey);

            if (archivos.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setArchivos(archivos.data || []);
            setDescargas([]);

            setBuscar(false);
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken, codigoEspecie, anioDisponible, codigoPuerto]);

    const filterDescargas = useCallback(async () =>
    {
        try
        {
            let tipos = '';

            tiposInformacion.forEach(tipoInformacion => { tipos += '&tipos_informacion[]=' + tipoInformacion; });

            const response = await axios.get(`${apiUrl}/v2/pesqueria/archivos/descargas?codigo_especie=${codigoEspecie}&anios_disponibles[]=${anioDisponible}&codigos_puertos[]=${codigoPuerto}${tipos}`);

            const descargas = verifyToken(response, appDebug, secretKey);

            if (descargas.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setDescargas(descargas.data || []);

            setCheckboxes(false);
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken, codigoEspecie, anioDisponible, codigoPuerto, tiposInformacion]);

    const fetchData = useCallback(async () =>
    {
        setFetch(true);

        try
        {
            const responseEstadisticas = await axios.get(`${apiUrl}/v2/pesqueria/estadisticas?environment=production`);

            const estadisticas = verifyToken(responseEstadisticas, appDebug, secretKey);

            if (estadisticas.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setEstadisticas(estadisticas.data || []);

            const responseBusqueda = await axios.get(`${apiUrl}/v2/pesqueria/busqueda?environment=production`);

            const busqueda = verifyToken(responseBusqueda, appDebug, secretKey);

            if (busqueda.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setSelectorEspecies(busqueda.especies.map(e =>
            ({
                value: `${e.COD_ESPECIE}`,
                label: e.NOMBRE_CIENTIFICO ? `${e.NOMBRE_ESPECIE} (${e.NOMBRE_CIENTIFICO})` : `${e.NOMBRE_ESPECIE}`,
            })));
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken]);

    const fetchSelectores = useCallback(async () =>
    {
        try
        {
            const response  = await axios.get(`${apiUrl}/v2/pesqueria/busqueda?codigo_especie=${codigoEspecie}&environment=production`);

            const data = verifyToken(response , appDebug, secretKey);

            if (data.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setSelectorAnios(data.anios.map(anio => ({ value: `${anio.ANIO}`, label: `${anio.ANIO}` })));

            setSelectorPuertos(data.puertos.map(puerto => ({ value: `${puerto.PUERTO_RECALADA}`, label: `${puerto.NOMBRE_PUERTO}` })));

            setSelectores(false);
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken, codigoEspecie]);

    useEffect(() =>
    {
        fetch === false && fetchData();
    }, [fetchData, fetch]);

    useEffect(() =>
    {
        selectores === true && fetchSelectores();
    }, [fetchSelectores, selectores]);

    useEffect(() =>
    {
        regiones === true && filterRegiones();
    }, [filterRegiones, regiones]);

    useEffect(() =>
    {
        buscar === true && filterArchivos();
    }, [filterArchivos, buscar]);

    useEffect(() =>
    {
        checkboxes === true && tiposInformacion.length === 0 && setDescargas([]);

        checkboxes === true && tiposInformacion.length > 0 && filterDescargas();
    }, [filterDescargas, checkboxes, tiposInformacion]);

    useEffect(() =>
    {
        if (!childCheckboxes)
        {
            if (descargas.length > 0)
            {
                const object = {};

                descargas.forEach((descarga) =>
                {
                    if (Object.hasOwn(checkboxesDescargasConsolidadas, descarga.NOMBRE_ARCHIVO))
                    {
                        object[descarga.NOMBRE_ARCHIVO] = checkboxesDescargasConsolidadas[descarga.NOMBRE_ARCHIVO];
                    }
                    else
                    {
                        object[descarga.NOMBRE_ARCHIVO] = true;
                    }
                });

                if (Object.keys(nombreArchivo)[0] !== undefined)
                {
                    const updatedObject =
                    {
                        ...checkboxesDescargasConsolidadas,
                        [Object.keys(nombreArchivo)[0]]: Object.values(nombreArchivo)[0]
                    };

                    setCheckboxesDescargasConsolidadas({ ...updatedObject });

                    handleDescargasConsolidadas(updatedObject);
                }
                else
                {
                    setCheckboxesDescargasConsolidadas({ ...object });

                    handleDescargasConsolidadas(object);
                }
            }
            else
            {
                setDescargasConsolidadas([]);
                setCheckboxesDescargasConsolidadas({});
            }

            setNombreArchivo({});
        }

        childCheckboxes && setChildCheckboxes(false);
    }, [childCheckboxes, descargas]);

    useEffect(() =>
    {
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }, [location]);

    // Tutorial Effects
    const handleCloseTour = () =>
    {
        setEnabledTour(false);
    };

    const handleStartTour = () =>
    {
        handleReset(); // Limpiar todo (filtros y resultados) para iniciar desde cero
        setEnabledTour(true);
    };

    return (
        <>
            <TourGuiaPublico
                enabled={enabledTour}
                onExit={handleCloseTour}
                onAutoFillEspecie={() =>
                {
                    if (!valueEspecie && selectorEspecies.length > 0) { handleSelectorEspecie(selectorEspecies[0]); }
                }}
                onAutoFillAnio={() =>
                {
                    if (!valueAnio && selectorAnios.length > 0) { handleSelectorAnio(selectorAnios[0]); }
                }}
                onAutoFillPuerto={() =>
                {
                    if (!valuePuerto && selectorPuertos.length > 0) { handleSelectorPuerto(selectorPuertos[0]); }
                }}
                setEspecie={setValueEspecie}
                setAnio={setValueAnio}
                setRegion={setValuePuerto}
            />

            <LoginModal
                show={showLoginModal}
                registerModal={() => setShowRegisterModal(true)}
                forgotPasswordModal={() => setShowForgotPasswordModal(true)}
                onClose={() =>
                {
                    setEmail('');
                    setPassword('');
                    setParams({});
                    setParamsConsolidados({});
                    setShowLoginModal(false);
                }}
                onLoginSuccess={() =>
                {
                    setShowLoginModal(false);

                    Object.keys(params).length > 0 && handleClick(params.archivo, params.url, params.tipo_informacion, params.subtipo_informacion, params.especie, params.puerto, params.anio);
                    Object.keys(paramsConsolidados).length > 0 && handleDownloadZip(paramsConsolidados.archivos, paramsConsolidados.url, paramsConsolidados.tipos_informacion, paramsConsolidados.subtipos_informacion, paramsConsolidados.especie, paramsConsolidados.puerto, paramsConsolidados.anio);
                }}
            />

            <RegisterModal
                show={showRegisterModal}
                loginModal={() => setShowLoginModal(true)}
                onClose={() => setShowRegisterModal(false)}
                onLoginSuccess={() => setShowRegisterModal(false)}
            />

            <ForgotPasswordModal
                show={showForgotPasswordModal}
                loginModal={() => setShowLoginModal(true)}
                onClose={() => setShowForgotPasswordModal(false)}
            />

            <div className="d-flex flex-column min-vh-100">
                <div className="container-fluid p-0 flex-grow-1 fondo-gris">
                    <div className="row row-cols-1 g-1 mb-2 buscador-avanzado overlay bg-cover px-3 px-md-5" style={{ backgroundImage: "linear-gradient(rgba(0, 51, 102, 0.7), rgba(0, 51, 102, 0.7)), url('https://datos.ifop.cl/buscador/resources/fondo-pesqueria.jpg')" }}>
                        <div className="row ps-1 ps-0 pe-0 pt-5 z-2 align-items-center">
                            <div className="col-5 col-md-1"><a href={`${publicUrl}/buscador-publico-v1`}><img src="blanco.png" alt="Logo IFOP" style={{ width: '100px' }} /></a></div>
                            <div className="col-5 col-lg-2 col-md-3 offset-2 offset-lg-9 offset-md-8 text-end align-content-center">
                                <div className="row align-items-center">
                                    <div className="col-4 text-center text-xl-end d-none">
                                        <button className="btn btn-sm rounded-circle" onClick={handleStartTour} title="Iniciar Tutorial" style={{ width: '38px', height: '38px', padding: '0', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffc107', border: 'none', transition: 'all 0.2s ease' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#000000" viewBox="0 0 16 16">
                                                <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.274a.5.5 0 0 0 .025-.917l-7.5-3.5ZM8 8.46 1.75 5.96 8 3.048l6.25 2.912L8 8.461Z" /><path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46l-3.892-1.556Z" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="col-8 text-center text-xl-end pe-0 d-none">
                                        <a href="https://datos.ifop.cl/" className="btn btn-secondary"><FontAwesomeIcon icon={faArrowLeft} /><span className="ms-2 d-none d-xl-inline">{'Volver'}</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row row-cols-6 g-2 z-2">
                            <div className="col-12 text-center">
                                <h1 className="text-white mb-3">Buscador de Datos Pesqueros (Público)</h1>
                                <p className="text-white mb-4 fs-3">Plataforma institucional para la exploración y descarga de datos pesqueros y biológicos</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-1 my-1 px-3 px-md-5">
                        <div className="col">
                            <div className="card custom-card h-100 p-3 pt-2">
                                <div className="card-body p-0">
                                    <h6 className="fw-bold text-muted text-uppercase mb-3"><Search size={16} className="me-2" />Filtros de exploración..</h6>
                                    <div className="row g-2">
                                        <div className="col-xl-4 col-lg-8 col-md-8 col-12" id="tour-pub-especie">
                                            <Select className="basic-single" classNamePrefix="select" styles={customStyles} isClearable name="especie" value={valueEspecie} onChange={handleSelectorEspecie} options={selectorEspecies} placeholder="Seleccione especie (*)" isDisabled={selectorEspecies.length === 0} />
                                        </div>
                                        <div className="col-xl-2 col-lg-4 col-md-4 col-12" id="tour-pub-anio">
                                            <Select className="basic-single" classNamePrefix="select" styles={customStyles} isClearable name="anio" value={valueAnio} onChange={handleSelectorAnio} options={selectorAnios} placeholder="Año" isDisabled={!valueEspecie} />
                                        </div>
                                        <div className="col-xl-3 col-lg-8 col-12" id="tour-pub-puerto">
                                            <Select className="basic-single" classNamePrefix="select" styles={customStyles} isClearable name="puerto" value={valuePuerto} onChange={handleSelectorPuerto} options={selectorPuertos} placeholder="Seleccione puerto (*)" isDisabled={regiones || !valueAnio} />
                                        </div>
                                        <div className="col-xl-3 col-lg-4 col-12 d-flex gap-2 justify-content-end" id="tour-pub-buscar">
                                            <button type="button" className="btn btn-warning flex-grow-1" onClick={handleBuscar} disabled={(!valueEspecie || !valueAnio || !valuePuerto) || buscar}>
                                                <Search size={18} className="me-1" /> Buscar
                                            </button>
                                            <button type="button" className="btn btn-secondary flex-grow-1 d-flex align-items-center justify-content-center gap-1" onClick={handleReset} disabled={(!valueEspecie || !valueAnio || !valuePuerto) || buscar}>
                                                <RotateCcw size={18} /> Limpiar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        filter === false &&
                        (
                            <div className="row g-1 my-1 px-3 px-md-5">
                                <div className="col">
                                    <div className="card-group shadow">

                                        {
                                            estadisticas.map((estadistica, id) =>
                                            (
                                                <div key={id} className="card bg-white">
                                                    <div className="card-body text-center">
                                                        <h2 className="fw-bold azulIfop estadisticas-numero"><CountUp separator="." end={estadistica.data} duration={3} /></h2>
                                                        <h2 className="text-muted estadisticas-texto">{estadistica.titulo}</h2>
                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </div>
                                    <div className="fade-in-animation">
                                        <div className="row g-1 mt-1">
                                            <Disclaimer />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    <div id="tour-pub-resultados-container" className="px-3 px-md-5">

                        {
                            archivos.length > 0 &&
                            (
                                <div className="fade-in-animation">
                                    <div className="row g-4 my-2">
                                        <div className="col-12 mt-1">
                                            <div className="card rounded-3 card-ai-gradient text-light p-3 pt-2 pb-2">
                                                <h2 className="h6 text-uppercase fw-bold mb-1 d-flex align-items-center"><Activity size={16} className="me-2" />Resultados de la Búsqueda (grupos y tipos de información con sus proyectos asociados)</h2>
                                            </div>
                                        </div>

                                        {
                                            archivos.map((archivo, index) =>
                                            (
                                                <div key={index} id={index === 0 ? "tour-pub-primer-card" : undefined} className="mt-3 col-lg-4 col-md-6">
                                                    <div className="card custom-card h-100 overflow-hidden">
                                                        <div className="card-header card-header-custom d-flex align-items-center justify-content-between p-2">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <div className="bg-white p-2 rounded shadow-sm border">{ICON_CONFIG[archivo.titulo_grupo_informacion]}</div>
                                                                <span className="fw-bold text-dark small text-uppercase">{archivo.titulo_grupo_informacion}</span>
                                                            </div>
                                                            <div className="fw-bold text-secondary bg-white border px-3 py-1 rounded-pill " style={{ fontSize: '0.75rem' }}>
                                                                Total: <span className="text-primary font-mono-data">{archivo.grupos_informacion.reduce((sum, value) => sum + Number(value.numero_registros_totales), 0).toLocaleString('es-CL')}</span>
                                                            </div>
                                                        </div>
                                                        <div className="card-body p-2">
                                                            <div className="ps-3 pe-3">

                                                                {
                                                                    archivo.grupos_informacion.map((informacion, subIndex) =>
                                                                    (
                                                                        <div key={subIndex}>
                                                                            <div className="d-flex justify-content-between align-items-center mb-2 small">
                                                                                <span className='col-1'>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input border-dark-subtle"
                                                                                        id={informacion.titulo_tipo_informacion}
                                                                                        onChange={(e) => handleCheckbox(e, informacion)}
                                                                                        checked={Object.hasOwn(checkboxesTiposInformacion, `${informacion.titulo_tipo_informacion}`) ? checkboxesTiposInformacion[`${informacion.titulo_tipo_informacion}`] : false}
                                                                                    />
                                                                                </span>
                                                                                <span className='col-9'><label htmlFor={informacion.titulo_tipo_informacion}>{informacion.titulo_tipo_informacion}</label></span>
                                                                                <span className="col-2 text-end font-mono-data fw-medium text-dark"> <label>{informacion.numero_registros_totales ? Number(informacion.numero_registros_totales).toLocaleString('es-CL') : 0}</label></span>
                                                                            </div>

                                                                            {
                                                                                checkboxesTiposInformacion[`${informacion.titulo_tipo_informacion}`] &&
                                                                                (
                                                                                    informacion.tipos_informacion.map((subInformacion, checkbox) =>
                                                                                    (
                                                                                        <div key={checkbox} className="ver_proyectos">
                                                                                            <div className="d-flex justify-content-between align-items-center mb-2 small">
                                                                                                <span className='col-1' />
                                                                                                <span className='col-1'>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        className="form-check-input border-dark-subtle"
                                                                                                        id={`${subInformacion.tipo_informacion} (${subInformacion.acronimo})`}
                                                                                                        value={`${subInformacion.tipo_informacion} (${subInformacion.acronimo})`}
                                                                                                        onChange={(e) => handleChildCheckbox(e, `${subInformacion.tipo_informacion} (${subInformacion.acronimo})`)}
                                                                                                        checked={Object.hasOwn(checkboxesSubtiposInformacion, `${subInformacion.tipo_informacion} (${subInformacion.acronimo})`) ? checkboxesSubtiposInformacion[`${subInformacion.tipo_informacion} (${subInformacion.acronimo})`] : false}
                                                                                                    />
                                                                                                </span>
                                                                                                <span className='col-8'><label className='ps-3' htmlFor={`${subInformacion.tipo_informacion} (${subInformacion.acronimo})`}>{subInformacion.tipo_informacion}</label></span>
                                                                                                <span className="col-2 text-end font-mono-data fw-medium text-dark"> <small>{subInformacion.numero_registros ? subInformacion.numero_registros.toLocaleString('es-CL') : 0}</small></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))
                                                                                )
                                                                            }

                                                                        </div>
                                                                    ))
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </div>

                                    {
                                        descargas.length > 0 &&
                                        (
                                            <section id="tour-pub-tabla-descargas" className="mb-5">
                                                <div className="row mb-2">
                                                    <div className="col-12 mt-1">
                                                        <div className="card rounded-3 card-ai-gradient text-light p-3 pt-2 pb-2 ">
                                                            <p className='mb-1'><b><Database size={16} className='me-2 mb-1' />Resultados para: </b> <b>Especie:</b> <i>{'"'}{valueEspecie.label}{'"'}</i>, <b>Año:</b> {'"'}{valueAnio.label}{'"'} y <b>Puerto:</b> {'"'}{valuePuerto.label}{'"'}{'.'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="data-grid-container">
                                                    <div className="table-responsive">
                                                        <table id="tablaResultados" className="table data-grid-table mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center">Grupo de información</th>
                                                                    <th className="text-center">Tipo de información</th>
                                                                    <th className="text-center">Proyecto</th>
                                                                    <th className="text-center">Nombre de archivo</th>
                                                                    <th className="text-center">Registros</th>
                                                                    <th className="text-center">Acción</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {
                                                                    descargas.map((descarga, index) =>
                                                                    (
                                                                        checkboxesSubtiposInformacion[`${descarga.NOMBRE_PROYECTO} (${descarga.ACRONIMO})`] === true &&
                                                                        (
                                                                            <tr key={index}>
                                                                                <td className='text-center'><span className={`badge-info-group ${getBadgeClass(descarga.GRUPO_INFORMACION)}`}>{descarga.GRUPO_INFORMACION}</span></td>
                                                                                <td className='text-center small'>{descarga.TIPO_INFORMACION}</td>
                                                                                <td className='text-center small'>{descarga.NOMBRE_PROYECTO}</td>
                                                                                <td className='text-center small'>{descarga.NOMBRE_ARCHIVO}</td>
                                                                                <td className='text-center font-mono-data fw-bold text-primary'>{descarga.NUM_REG > 0 && descarga.NUM_REG.toLocaleString('es-CL')}</td>
                                                                                <td className='text-center'>

                                                                                    {
                                                                                        descarga.NOMBRE &&
                                                                                        (
                                                                                            token ?
                                                                                            (
                                                                                                <a href={`${repositorioUrl}/${descarga.REPOSITORIO}/${descarga.NOMBRE}`}
                                                                                                    className="btn btn-sm btn-outline-success d-inline-flex align-items-center gap-1"
                                                                                                    id="download"
                                                                                                    onClick={() => handleClick(descarga.NOMBRE, url, descarga.TIPO_INFORMACION, descarga.NOMBRE_PROYECTO, valueEspecie, valuePuerto, anioDisponible)}
                                                                                                    download>
                                                                                                    <FileSpreadsheet size={14} /> XLSX
                                                                                                </a>
                                                                                            ) :
                                                                                            (
                                                                                                <a className="btn btn-sm btn-outline-success d-inline-flex align-items-center gap-1"
                                                                                                    onClick={() => { setShowLoginModal(true); handleOpciones(`${repositorioUrl}/${descarga.REPOSITORIO}/${descarga.NOMBRE}`, descarga.NOMBRE, url, descarga.TIPO_INFORMACION, descarga.NOMBRE_PROYECTO, valueEspecie, valuePuerto, anioDisponible); }}>
                                                                                                    <FileSpreadsheet size={14} /> XLSX
                                                                                                </a>
                                                                                            )
                                                                                        )
                                                                                    }

                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    ))
                                                                }

                                                                {
                                                                    descargasConsolidadas.length > 0 &&
                                                                    (
                                                                        <tr id="tour-pub-boton-descarga-grupal">
                                                                            <td colSpan="4" />
                                                                            <td colSpan="2" className='text-end'>

                                                                                {
                                                                                    token ?
                                                                                    (
                                                                                        <button type="button"
                                                                                            className="btn card-ai-gradient text-light w-100 py-2 d-flex align-items-center justify-content-center gap-2 fw-bold shadow-sm"
                                                                                            onClick={() => { handleDownloadZip(descargasConsolidadas, url, tiposInformacion, subtiposInformacion, valueEspecie, valuePuerto, anioDisponible); setDescargar(true); }}
                                                                                            disabled={descargar}>
                                                                                            <Download size={20} /> Descargar
                                                                                        </button>
                                                                                    ) :
                                                                                    (
                                                                                        <button type="button"
                                                                                            className="btn card-ai-gradient text-light w-100 py-2 d-flex align-items-center justify-content-center gap-2 fw-bold shadow-sm"
                                                                                            onClick={() => { setShowLoginModal(true); handleOpcionesConsolidadas(descargasConsolidadas, url, tiposInformacion, subtiposInformacion, valueEspecie, valuePuerto, anioDisponible); }}>
                                                                                            <Download size={20} /> Descargar
                                                                                        </button>
                                                                                    )
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </section>
                                        )
                                    }

                                </div>
                            )
                        }

                    </div>
                </div>

                <Footer />

            </div >
        </>
    );
};

export default PesqueriaNuevoV2Page;
